const useTour = () => {
  return window.tour;
};

export default useTour;
